import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import UsersPage from './pages/UsersPage';
import UserPage from './pages/UserPage';
import AdminPage from '../pages/AdminPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage tab="users" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <UserPage />,
      },
    ],
  },
];

export default routes;
